export default "__VITE_ASSET__0d982b10__"